/* Filtrous shared merch maps - v1.1, 2026-08-26 (Adelaide). ONE source of
   truth for the merchandising relations, published as window.FV3_MERCH and
   read by BOTH assets/filtrous-pdp-merch.js (PDP rails) and
   assets/filtrous-cart-upsell.js (cart-drawer suggestions) - extracted from
   the PDP asset when the drawer gained suggestions, so the two surfaces can
   never drift apart.
   - WORKFLOW: family -> the families a lab uses ALONGSIDE it (order =
     strength). The "outfit" relation.
   - UPSELL: family -> its "whole kit / complete system" families. The
     step-up relation (buffers -> extraction/PCR kits, vials/filters ->
     autosampler kits, swabs -> VTM kits, culture ware -> media, ...).
   - KIT_FAMS: the families whose items carry the "Full kit" badge.
   v1.1: eight consumable families had NO upsell target, so their PDPs and
   carts led with no kit at all - against the standing rule (Adelaide: "if I
   am buying a buffer, I should want the whole kit... always upsell in both
   protocol and recommended with the same thing attached to price anchor").
   PPE, dispensing/glass pipettes, scintillation vials, culture media and
   lab equipment now each anchor to the kit their workflow actually
   consumes. The five KIT families themselves stay deliberately empty - you
   do not sell a second kit to someone who just bought one; the rails fall
   back to pricier workflow companions there.
   Handles are live primary_family values from catalog-index.json
   (2026-08-26 build) - revisit when the index regenerates with new families.
   Loaded non-deferred before the PDP merch asset in
   sections/filtrous-v3-app.liquid and deferred from
   snippets/filtrous-cart-drawer.liquid (the drawer renders on every page);
   the guard below makes double-inclusion harmless. Additive asset. */
(function () {
  'use strict';
  if (window.FV3_MERCH) return;
  window.FV3_MERCH = {
    WORKFLOW: {
      'weighing-v2': ['glassware-plastics-v2', 'solvents-v2', 'biology-buffers-v2', 'gloves-v2', 'centrifuge-tubes-v2', 'chemistry-reagents', 'scintillation-vials-v2'],
      'syringe-filters-v2': ['syringes-v2', 'autosampler-vials-caps-v2', 'vial-inserts-v2', 'solvents-v2', 'gloves-v2', 'headspace-vials-v2'],
      'syringes-v2': ['syringe-filters-v2', 'autosampler-vials-caps-v2', 'solvents-v2', 'gloves-v2', 'biohazard-bags-v2'],
      'autosampler-vials-caps-v2': ['vial-inserts-v2', 'syringe-filters-v2', 'autosampler-kits-v2', 'solvents-v2', 'syringes-v2'],
      'autosampler-kits-v2': ['syringe-filters-v2', 'solvents-v2', 'vial-inserts-v2', 'syringes-v2'],
      'vial-inserts-v2': ['autosampler-vials-caps-v2', 'autosampler-kits-v2', 'syringe-filters-v2'],
      'headspace-vials-v2': ['autosampler-kits-v2', 'solvents-v2', 'syringes-v2', 'syringe-filters-v2'],
      'epa-voa-vials-v2': ['solvents-v2', 'syringe-filters-v2', 'syringes-v2', 'gloves-v2'],
      'scintillation-vials-v2': ['solvents-v2', 'pipettes-v2', 'serological-pipettes-v2', 'gloves-v2', 'weighing-v2'],
      'filter-vials-v2': ['autosampler-vials-caps-v2', 'solvents-v2', 'syringes-v2'],
      'filter-paper-v2': ['glassware-plastics-v2', 'solvents-v2', 'weighing-v2', 'gloves-v2'],
      'membrane-filters-v2': ['glassware-plastics-v2', 'solvents-v2', 'gloves-v2'],
      'filter-plates-v2': ['96-deep-well-plates-v2', 'pcr-plates-v2', 'robotic-tips-v2', 'sealing-membranes-v2', 'centrifuge-tubes-v2'],
      'cell-strainers-filters-v2': ['culture-flasks-v2', 'culture-dishes-v2', 'cell-maintenance-v2', 'serological-pipettes-v2', 'centrifuge-tubes-v2'],
      'cell-maintenance-v2': ['culture-flasks-v2', 'culture-dishes-v2', 'serological-pipettes-v2', 'cell-strainers-filters-v2', 'centrifuge-tubes-v2', 'gloves-v2', 'universal-tips-v2'],
      'culture-dishes-v2': ['cell-maintenance-v2', 'serological-pipettes-v2', 'inoculating-loops-v2', 'gloves-v2', 'cell-strainers-filters-v2'],
      'culture-flasks-v2': ['cell-maintenance-v2', 'serological-pipettes-v2', 'cell-strainers-filters-v2', 'gloves-v2'],
      'inoculating-loops-v2': ['culture-dishes-v2', 'cell-maintenance-v2', 'gloves-v2'],
      'centrifuge-tubes-v2': ['pipettes-v2', 'universal-tips-v2', 'biology-buffers-v2', 'cold-blocks-v2', 'gloves-v2'],
      'strip-tubes-v2': ['pcr-kits-reagents-v2', 'master-mix-v2', 'pcr-plates-v2', 'lts-pipette-tips-v2', 'universal-tips-v2', 'cold-blocks-v2'],
      'pcr-plates-v2': ['pcr-kits-reagents-v2', 'master-mix-v2', 'sealing-membranes-v2', 'strip-tubes-v2', 'robotic-tips-v2', 'cold-blocks-v2'],
      'pcr-kits-reagents-v2': ['pcr-plates-v2', 'strip-tubes-v2', 'master-mix-v2', 'universal-tips-v2', 'cold-blocks-v2', 'gloves-v2', 'extraction-kits-v2'],
      'master-mix-v2': ['pcr-plates-v2', 'strip-tubes-v2', 'pcr-kits-reagents-v2', 'universal-tips-v2', 'cold-blocks-v2'],
      'sealing-membranes-v2': ['pcr-plates-v2', '96-deep-well-plates-v2', 'filter-plates-v2', 'robotic-tips-v2'],
      '96-deep-well-plates-v2': ['sealing-membranes-v2', 'robotic-tips-v2', 'filter-plates-v2', 'pcr-kits-reagents-v2', 'centrifuge-tubes-v2'],
      'extraction-kits-v2': ['extraction-buffers-v2', 'centrifuge-tubes-v2', 'universal-tips-v2', 'pipettes-v2', 'pcr-kits-reagents-v2', 'gloves-v2', '96-deep-well-plates-v2'],
      'extraction-buffers-v2': ['extraction-kits-v2', 'centrifuge-tubes-v2', 'universal-tips-v2', 'gloves-v2'],
      'quechers-v2': ['centrifuge-tubes-v2', 'solvents-v2', 'syringe-filters-v2', 'autosampler-vials-caps-v2', 'weighing-v2'],
      'sample-preparation-v2': ['centrifuge-tubes-v2', 'solvents-v2', 'syringe-filters-v2', 'pipettes-v2', 'weighing-v2'],
      'biological-specimen-collection-v2': ['vtm-v2', 'nabs-v2', 'biohazard-bags-v2', 'gloves-v2', 'masks-v2', 'centrifuge-tubes-v2'],
      'vtm-v2': ['biological-specimen-collection-v2', 'nabs-v2', 'gloves-v2', 'biohazard-bags-v2', 'cold-blocks-v2'],
      'nabs-v2': ['vtm-v2', 'biological-specimen-collection-v2', 'gloves-v2', 'masks-v2'],
      'biohazard-bags-v2': ['gloves-v2', 'masks-v2', 'biological-specimen-collection-v2'],
      'gloves-v2': ['masks-v2', 'biohazard-bags-v2', 'glassware-plastics-v2', 'weighing-v2'],
      'masks-v2': ['gloves-v2', 'biohazard-bags-v2'],
      'pipettes-v2': ['universal-tips-v2', 'lts-pipette-tips-v2', 'centrifuge-tubes-v2', 'biology-buffers-v2', 'gloves-v2'],
      'universal-tips-v2': ['pipettes-v2', 'centrifuge-tubes-v2', 'strip-tubes-v2', 'biology-buffers-v2', 'pcr-kits-reagents-v2'],
      'lts-pipette-tips-v2': ['pipettes-v2', 'centrifuge-tubes-v2', 'pcr-plates-v2'],
      'robotic-tips-v2': ['96-deep-well-plates-v2', 'pcr-plates-v2', 'sealing-membranes-v2', 'filter-plates-v2'],
      'dispenser-tips-v2': ['solvents-v2', 'glassware-plastics-v2', 'scintillation-vials-v2'],
      'serological-pipettes-v2': ['cell-maintenance-v2', 'culture-flasks-v2', 'culture-dishes-v2', 'centrifuge-tubes-v2', 'gloves-v2'],
      'glass-pipettes-v2': ['glassware-plastics-v2', 'solvents-v2', 'biology-buffers-v2'],
      'graduated-pipettes-v2': ['glassware-plastics-v2', 'solvents-v2', 'biology-buffers-v2'],
      'glassware-plastics-v2': ['weighing-v2', 'solvents-v2', 'biology-buffers-v2', 'filter-paper-v2', 'gloves-v2', 'glass-pipettes-v2'],
      'biology-buffers-v2': ['centrifuge-tubes-v2', 'pipettes-v2', 'universal-tips-v2', 'glassware-plastics-v2', 'ph-buffers-v2'],
      'ph-buffers-v2': ['glassware-plastics-v2', 'biology-buffers-v2', 'lab-equipment-v2', 'gloves-v2'],
      'chemistry-reagents': ['glassware-plastics-v2', 'weighing-v2', 'gloves-v2', 'solvents-v2', 'filter-paper-v2'],
      'solvents-v2': ['syringe-filters-v2', 'autosampler-vials-caps-v2', 'glassware-plastics-v2', 'gloves-v2', 'dispenser-tips-v2', 'scintillation-vials-v2'],
      'cold-blocks-v2': ['strip-tubes-v2', 'pcr-plates-v2', 'centrifuge-tubes-v2', 'master-mix-v2'],
      'lab-equipment-v2': ['glassware-plastics-v2', 'weighing-v2', 'ph-buffers-v2', 'gloves-v2']
    },
    UPSELL: {
      'biology-buffers-v2': ['extraction-kits-v2', 'pcr-kits-reagents-v2'],
      'extraction-buffers-v2': ['extraction-kits-v2'],
      'ph-buffers-v2': ['extraction-kits-v2'],
      'syringe-filters-v2': ['autosampler-kits-v2'],
      'syringes-v2': ['autosampler-kits-v2'],
      'autosampler-vials-caps-v2': ['autosampler-kits-v2'],
      'vial-inserts-v2': ['autosampler-kits-v2'],
      'headspace-vials-v2': ['autosampler-kits-v2'],
      'filter-vials-v2': ['autosampler-kits-v2'],
      'epa-voa-vials-v2': ['autosampler-kits-v2'],
      'solvents-v2': ['quechers-v2', 'extraction-kits-v2'],
      'centrifuge-tubes-v2': ['extraction-kits-v2'],
      'universal-tips-v2': ['pcr-kits-reagents-v2', 'extraction-kits-v2'],
      'lts-pipette-tips-v2': ['pcr-kits-reagents-v2'],
      'robotic-tips-v2': ['extraction-kits-v2'],
      'strip-tubes-v2': ['pcr-kits-reagents-v2'],
      'pcr-plates-v2': ['pcr-kits-reagents-v2'],
      '96-deep-well-plates-v2': ['extraction-kits-v2'],
      'filter-plates-v2': ['extraction-kits-v2'],
      'sealing-membranes-v2': ['pcr-kits-reagents-v2'],
      'master-mix-v2': ['pcr-kits-reagents-v2'],
      'cold-blocks-v2': ['pcr-kits-reagents-v2'],
      'nabs-v2': ['vtm-v2'],
      'biological-specimen-collection-v2': ['vtm-v2'],
      'biohazard-bags-v2': ['vtm-v2'],
      'sample-preparation-v2': ['extraction-kits-v2'],
      'weighing-v2': ['sample-preparation-v2', 'quechers-v2'],
      'glassware-plastics-v2': ['sample-preparation-v2'],
      'membrane-filters-v2': ['extraction-kits-v2'],
      'filter-paper-v2': ['quechers-v2'],
      'quechers-v2': ['extraction-kits-v2'],
      'chemistry-reagents': ['quechers-v2'],
      'pipettes-v2': ['extraction-kits-v2'],
      'serological-pipettes-v2': ['cell-maintenance-v2'],
      'culture-dishes-v2': ['cell-maintenance-v2'],
      'culture-flasks-v2': ['cell-maintenance-v2'],
      'cell-strainers-filters-v2': ['cell-maintenance-v2'],
      'inoculating-loops-v2': ['cell-maintenance-v2'],
      /* v1.1 - the families that previously anchored to nothing. PPE and
         collection consumables step up to the collection/extraction kits
         that consume them; dispensing and glass pipettes to solvent prep;
         culture media to the molecular kits downstream of a culture. */
      'gloves-v2': ['vtm-v2', 'extraction-kits-v2'],
      'masks-v2': ['vtm-v2', 'extraction-kits-v2'],
      'dispenser-tips-v2': ['quechers-v2', 'extraction-kits-v2'],
      'glass-pipettes-v2': ['quechers-v2', 'sample-preparation-v2'],
      'graduated-pipettes-v2': ['sample-preparation-v2', 'quechers-v2'],
      'scintillation-vials-v2': ['quechers-v2', 'autosampler-kits-v2'],
      'cell-maintenance-v2': ['extraction-kits-v2', 'pcr-kits-reagents-v2'],
      'lab-equipment-v2': ['sample-preparation-v2', 'extraction-kits-v2']
      /* extraction-kits-v2 / pcr-kits-reagents-v2 / autosampler-kits-v2 /
         vtm-v2 stay absent on purpose: no second kit for a kit buyer. */
    },
    KIT_FAMS: { 'extraction-kits-v2': 1, 'pcr-kits-reagents-v2': 1, 'autosampler-kits-v2': 1, 'quechers-v2': 1, 'vtm-v2': 1 }
  };
})();
